<div *ngIf="book && book.body && book.cover" class="project-book-container">

  <!-- ===== PRODUCT EDITING AREA (top, collapsible) ===== -->
  <div class="product-editor-section">
    <div class="section-header" (click)="showProductEditor = !showProductEditor">
      <mat-icon>{{showProductEditor ? 'expand_less' : 'expand_more'}}</mat-icon>
      <span i18n="@@ProductBookDetails">Product & Book Details</span>
      <span *ngIf="!product" class="no-product-hint">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">info_outline</mat-icon>
        <span i18n="@@No product found for this book">No product found for this book</span>
      </span>
    </div>

    <div *ngIf="showProductEditor" class="product-editor-body">
      <!-- Save / Cancel bar -->
      <div class="save-cancel-bar" *ngIf="isDirty">
        <button mat-raised-button color="primary" (click)="saveAll()" i18n-title="@@Save Changes" title="Save Changes">
          <mat-icon>save</mat-icon> <span i18n="@@Save">Save</span>
        </button>
        <button mat-stroked-button (click)="cancelChanges()" i18n-title="@@Cancel Changes" title="Cancel Changes">
          <mat-icon>undo</mat-icon> <span i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</span>
        </button>
      </div>

      <!-- Shared fields (Book + Product) -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-half">
          <mat-label i18n="@@Sub Title">Sub Title</mat-label>
          <input matInput [(ngModel)]="book.subtitle" (ngModelChange)="saveSharedSubtitle($event)" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@Author">Author</mat-label>
          <input matInput [(ngModel)]="book.author" (ngModelChange)="saveSharedAuthor($event)" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@ISBN / EAN13">ISBN / EAN13</mat-label>
          <input matInput [(ngModel)]="book.isbn" (ngModelChange)="saveSharedIsbn($event)" [ngModelOptions]="{standalone: true}" maxlength="13">
          <mat-hint *ngIf="book.isbn && !isValidEAN13(book.isbn)" style="color: red;" i18n="@@Invalid EAN13">Invalid EAN13</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@Publication Year">Publication Year</mat-label>
          <input matInput type="number" [(ngModel)]="book.publicationYear" (ngModelChange)="saveSharedPublicationYear($event)" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </div>

      <!-- Book-only editable fields -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@SFBN">SFBN</mat-label>
          <input matInput [(ngModel)]="book.sfbn" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@Language Code">Language Code</mat-label>
          <input matInput
                 [ngModel]="book.languageCode"
                 (ngModelChange)="languageFilter = $event; saveSharedLanguageCode($event)"
                 [matAutocomplete]="bookLangAuto"
                 [ngModelOptions]="{standalone: true}"
                 i18n-placeholder="@@Language"
                 placeholder="Language">
          <mat-autocomplete #bookLangAuto="matAutocomplete"
                            (optionSelected)="saveSharedLanguageCode($event.option.value)">
            <mat-option *ngFor="let lang of filteredLanguages()" [value]="lang.iso639_3">
              {{ languageDisplayName(lang) }}
              <span class="lang-code-hint">({{ lang.iso639_3 }}<span *ngIf="lang.iso639_2">, {{ lang.iso639_2 }}</span>)</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@MSRP">MSRP</mat-label>
          <input matInput [(ngModel)]="book.msrp" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@Case Quantity">Case Quantity</mat-label>
          <input matInput type="number" [(ngModel)]="book.caseQuantity" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@Tag ID">Tag Id</mat-label>
          <input matInput type="number" [(ngModel)]="book.tagId" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field-third">
          <mat-label i18n="@@Note">Note</mat-label>
          <input matInput [(ngModel)]="book.comment" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </div>

      <!-- Product-only fields -->
      <ng-container *ngIf="product">
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-half">
            <mat-label i18n="@@Customer Product ID">Customer Product Id</mat-label>
            <input matInput [(ngModel)]="product.customerProduct_ID" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field-quarter">
            <mat-label i18n="@@MSRP Currency">MSRP Currency</mat-label>
            <input matInput [(ngModel)]="product.msrpCurrency" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}" maxlength="3">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field-quarter">
            <mat-label i18n="@@Upstream Cost">Upstream Cost</mat-label>
            <input matInput [(ngModel)]="product.upstreamCost" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-half">
            <mat-label i18n="@@Short Description">Short Description</mat-label>
            <textarea matInput [(ngModel)]="product.shortDescription" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}" rows="2"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field-half">
            <mat-label i18n="@@Preview Pages">Preview Pages</mat-label>
            <input matInput [(ngModel)]="product.previewPages" (ngModelChange)="markDirty()" [ngModelOptions]="{standalone: true}" i18n-placeholder="@@Comma separated page numbers" placeholder="Comma separated page numbers">
            <mat-hint i18n="@@Max pages hint">Max: {{book.body?.numPages}} pages</mat-hint>
          </mat-form-field>
        </div>

        <!-- Rich text description editor -->
        <div class="description-editor">
          <mat-label i18n="@@Description">Description</mat-label>
          <quill-editor
            [(ngModel)]="product.description"
            [modules]="quillConfig"
            [styles]="{'height': '150px', 'margin-bottom': '10px'}"
            (onContentChanged)="markDirty()"
            i18n-placeholder="@@Start writing the product description here..."
            placeholder="Start writing the product description here...">
          </quill-editor>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- ===== IMMUTABLE PROPERTIES (compact, collapsible) ===== -->
  <div class="immutable-section">
    <div class="section-header" (click)="showImmutableProps = !showImmutableProps">
      <mat-icon>{{showImmutableProps ? 'expand_less' : 'expand_more'}}</mat-icon>
      <span i18n="@@Book Properties">Book Properties</span>
    </div>
    <div *ngIf="showImmutableProps" class="immutable-body">
      <div class="props-grid">
        <div class="prop-item">
          <span class="prop-label" i18n="@@Trim Size">Trim Size</span>
          <span class="prop-value">{{formatTrim()}}</span>
        </div>
        <div class="prop-item">
          <span class="prop-label" i18n="@@Binding">Binding</span>
          <span class="prop-value">{{getLanguageString(book.bindingType)}}</span>
        </div>
        <div class="prop-item">
          <span class="prop-label" i18n="@@Interior">Interior</span>
          <span class="prop-value">{{getLanguageString(book.interiorType)}}</span>
        </div>
        <div class="prop-item">
          <span class="prop-label" i18n="@@Paper Type">Paper Type</span>
          <span class="prop-value">{{getPaperTypeName(book.body?.paperType_ID)}}</span>
        </div>
        <div class="prop-item">
          <span class="prop-label" i18n="@@Lamination">Lamination</span>
          <span class="prop-value">{{getLanguageString(book.cover?.laminateType)}}</span>
        </div>
        <div class="prop-item">
          <span class="prop-label" i18n="printed pages|Count of pages in the book. One physical sheet carries several pages, so this must not share a word with Sheets.@@Pages">Pages</span>
          <span class="prop-value">{{book.body?.numPages}}</span>
        </div>
      </div>
      <!-- Cover row -->
      <div class="resource-detail-row">
        <span class="prop-label" style="font-weight: bold; min-width: 40px;" i18n="@@Cover">Cover</span>
        <span class="resource-id-badge"
              [style.background-color]="getResourceStatusColor(book.cover)"
              [style.background-image]="getResourceStripe(book.cover)"
              [class.res-badge-actionable]="isResourceActionable(book.cover)"
              [attr.role]="isResourceActionable(book.cover) ? 'button' : null"
              [attr.tabindex]="isResourceActionable(book.cover) ? 0 : null"
              (click)="onResourceBadgeClick(book.cover, true, $event)"
              (keydown.enter)="onResourceBadgeClick(book.cover, true, $event)"
              (keydown.space)="onResourceBadgeClick(book.cover, true, $event)"
              [title]="getResourceHoverText(book.cover, 'Cover Resource ID')">{{getResourceDisplayString(book.cover)}}</span>
        <span class="status-badge-inline" [ngClass]="getStatusClass(book.cover?.standardized || 'UNKNOWN')" i18n-title="@@Cover Standardized" title="Cover Standardized">{{getStatusLabel(book.cover?.standardized || 'UNKNOWN')}}</span>
        <span class="prop-value" i18n-title="@@Cover Scale" title="Cover Scale">{{formatScale(book.cover?.documentScale)}}</span>
        <span class="prop-value" i18n-title="@@Cover Vertical Shift" title="Cover Vertical Shift">{{formatShift(book.cover?.verticalShift)}}</span>
        <span class="prop-value" i18n-title="@@Cover Horizontal Shift" title="Cover Horizontal Shift">{{formatShift(book.cover?.horizontalShift)}}</span>
        <span class="download-buttons">
          <button *ngIf="canStandardizeCover" mat-button (click)="standardizeCover()" i18n-title="@@Standardize Cover" title="Standardize Cover" class="download-btn standardize-btn">
            <mat-icon>play_circle_outline</mat-icon><span i18n="@@Standardize">Standardize</span>
          </button>
          <button *ngIf="book.cover?.standardized === 'COMPLETE'" mat-button (click)="downloadStandardizedCover()" i18n-title="@@Download Standardized Cover" title="Download Standardized Cover" class="download-btn">
            <mat-icon>download</mat-icon><span i18n="@@Standardized">Standardized</span>
          </button>
          <button *ngIf="book.cover?.resource_ID" mat-button (click)="downloadOriginalCover()" i18n-title="@@Download Original Cover PDF" title="Download Original Cover PDF" class="download-btn">
            <mat-icon>file_download</mat-icon><span i18n="@@Original">Original</span>
          </button>
        </span>
      </div>

      <!-- Body row -->
      <div class="resource-detail-row">
        <span class="prop-label" style="font-weight: bold; min-width: 40px;" i18n="@@Body">Body</span>
        <span class="resource-id-badge"
              [style.background-color]="getResourceStatusColor(book.body)"
              [style.background-image]="getResourceStripe(book.body)"
              [class.res-badge-actionable]="isResourceActionable(book.body)"
              [attr.role]="isResourceActionable(book.body) ? 'button' : null"
              [attr.tabindex]="isResourceActionable(book.body) ? 0 : null"
              (click)="onResourceBadgeClick(book.body, false, $event)"
              (keydown.enter)="onResourceBadgeClick(book.body, false, $event)"
              (keydown.space)="onResourceBadgeClick(book.body, false, $event)"
              [title]="getResourceHoverText(book.body, 'Body Resource ID')">{{getResourceDisplayString(book.body)}}</span>
        <span class="status-badge-inline" [ngClass]="getStatusClass(book.body?.standardized || 'UNKNOWN')" i18n-title="@@Body Standardized" title="Body Standardized">{{getStatusLabel(book.body?.standardized || 'UNKNOWN')}}</span>
        <span class="prop-value" i18n-title="@@Body Scale" title="Body Scale">{{formatScale(book.body?.documentScale)}}</span>
        <span class="prop-value" i18n-title="@@Body Left Vertical Shift" title="Body Left Vertical Shift">{{formatShift(book.body?.leftVerticalShift)}}</span>
        <span class="prop-value" i18n-title="@@Body Left Horizontal Shift" title="Body Left Horizontal Shift">{{formatShift(book.body?.leftHorizontalShift)}}</span>
        <span class="prop-value" i18n-title="@@Body Right Vertical Shift" title="Body Right Vertical Shift">{{formatShift(book.body?.rightVerticalShift)}}</span>
        <span class="prop-value" i18n-title="@@Body Right Horizontal Shift" title="Body Right Horizontal Shift">{{formatShift(book.body?.rightHorizontalShift)}}</span>
        <span class="download-buttons">
          <button *ngIf="canStandardizeBody" mat-button (click)="standardizeBody()" i18n-title="@@Standardize Body" title="Standardize Body" class="download-btn standardize-btn">
            <mat-icon>play_circle_outline</mat-icon><span i18n="@@Standardize">Standardize</span>
          </button>
          <button *ngIf="book.body?.standardized === 'COMPLETE'" mat-button (click)="downloadStandardizedBody()" i18n-title="@@Download Standardized Body" title="Download Standardized Body" class="download-btn">
            <mat-icon>download</mat-icon><span i18n="@@Standardized">Standardized</span>
          </button>
          <button *ngIf="book.body?.resource_ID" mat-button (click)="downloadOriginalBody()" i18n-title="@@Download Original Body PDF" title="Download Original Body PDF" class="download-btn">
            <mat-icon>file_download</mat-icon><span i18n="@@Original">Original</span>
          </button>
        </span>
      </div>

      <!-- Process files button -->
      <div class="file-status-row" *ngIf="canProcessFiles || filesProcessing">
        <button *ngIf="canProcessFiles" mat-raised-button color="primary" (click)="processPdfFiles()" i18n-title="@@Process PDF Files" title="Process PDF Files">
          <mat-icon>play_circle_outline</mat-icon>
          <span i18n="@@Process PDF Files">Process PDF Files</span>
        </button>
        <mat-spinner *ngIf="filesProcessing" diameter="20" style="margin-left: 8px;"></mat-spinner>
      </div>

      <!--
        Resource problems.

        Driven by `prepared === 'ERROR'`, not by `problems` being non-empty.
        Those are not the same test: a resource can fail preparation and come
        back with an empty `problems` string, and the previous version rendered
        nothing at all in that case — the user saw a red status badge and no
        explanation. The `@@No details were provided` fallback covers it.

        `problemNote` is separate and informational, so it still shows on its
        own regardless of `prepared`.
      -->
      <div *ngIf="hasResourceProblems" class="problems-area">
        <div *ngIf="coverHasError" class="problem-item error-text">
          <mat-icon>warning</mat-icon>
          <span><strong i18n="@@Cover">Cover</strong>:
            <ng-container *ngIf="coverResource?.problems">{{coverResource.problems}}</ng-container>
            <ng-container *ngIf="!coverResource?.problems" i18n="@@No details were provided">No details were provided</ng-container>
          </span>
        </div>
        <div *ngIf="coverResource?.problemNote" class="problem-item">
          <mat-icon>info</mat-icon>
          <span><strong i18n="@@Cover">Cover</strong>: {{coverResource.problemNote}}</span>
        </div>
        <div *ngIf="bodyHasError" class="problem-item error-text">
          <mat-icon>warning</mat-icon>
          <span><strong i18n="@@Body">Body</strong>:
            <ng-container *ngIf="bodyResource?.problems">{{bodyResource.problems}}</ng-container>
            <ng-container *ngIf="!bodyResource?.problems" i18n="@@No details were provided">No details were provided</ng-container>
          </span>
        </div>
        <div *ngIf="bodyResource?.problemNote" class="problem-item">
          <mat-icon>info</mat-icon>
          <span><strong i18n="@@Body">Body</strong>: {{bodyResource.problemNote}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== COVER PREVIEW (standardized, read-only) ===== -->
  <div class="preview-section" *ngIf="canPreviewCover">
    <div class="section-header-small">
      <mat-icon>auto_stories</mat-icon>
      <span i18n="@@Cover Preview">Cover Preview</span>
      <div class="zoom-controls">
        <mat-icon class="zoom-icon">search</mat-icon>
        <mat-slider [min]="25" [max]="800" [step]="5" style="flex: 1; min-width: 100px;" i18n-title="@@Zoom" title="Zoom"><input matSliderThumb [value]="coverZoom" (valueChange)="coverZoom = $event" /></mat-slider>
        <span class="zoom-label">{{effectiveCoverZoom}}%</span>
        <button mat-icon-button (click)="fitCoverToWidth()" i18n-title="@@Fit to Width" title="Fit to Width"><mat-icon>fit_screen</mat-icon></button>
      </div>
    </div>
    <div class="cover-preview-area" #coverPreviewArea style="overflow: auto;">
      <div class="cover-center-wrapper" #coverContent [style.width.px]="scaledCoverWidth || null" [style.height.px]="scaledCoverHeight || null" style="overflow: hidden; margin: 0 auto;">
        <div [style.transform]="'scale(' + effectiveCoverZoom / 100 + ')'" [style.transform-origin]="'top left'" style="display: inline-block;">
          <app-book-preview-cover
            [book]="book"
            [dpi]="288">
          </app-book-preview-cover>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="book.cover?.standardized !== 'COMPLETE'" class="status-placeholder-small">
    <mat-icon>auto_stories</mat-icon>
    <span i18n="@@Cover">Cover</span>: {{getStatusLabel(book.cover?.standardized || 'UNKNOWN')}}
  </div>

  <!-- ===== INTERIOR PAGES (standardized, read-only) ===== -->
  <div class="preview-section" *ngIf="canPreviewBody">
    <div class="section-header-small">
      <mat-icon>description</mat-icon>
      <span i18n="@@Interior Pages">Interior Pages</span>
      <span style="color: #ccc; font-size: 12px; margin-left: 8px;">{{book.body?.numPages}} <span i18n="@@pages">pages</span></span>
      <div class="zoom-controls">
        <mat-icon class="zoom-icon">search</mat-icon>
        <mat-slider [min]="25" [max]="800" [step]="5" style="flex: 1; min-width: 100px;" i18n-title="@@Zoom" title="Zoom"><input matSliderThumb [value]="interiorZoom" (valueChange)="interiorZoom = $event" /></mat-slider>
        <span class="zoom-label">{{effectiveInteriorZoom}}%</span>
        <button mat-icon-button (click)="fitInteriorToWidth()" i18n-title="@@Fit to Width" title="Fit to Width"><mat-icon>fit_screen</mat-icon></button>
      </div>
    </div>

    <!-- Page range controls -->
    <div class="page-range-bar">
      <button mat-icon-button [disabled]="!hasPreviousPages" (click)="showPreviousPages()" i18n-title="@@Previous Pages" title="Previous Pages"><mat-icon>chevron_left</mat-icon></button>
      <span class="page-range-label" i18n="printed pages|Count of pages in the book. One physical sheet carries several pages, so this must not share a word with Sheets.@@Pages">Pages</span>
      <mat-form-field class="page-range-input" appearance="outline">
        <input matInput type="number" [(ngModel)]="interiorPageStart" [ngModelOptions]="{standalone: true}" min="1" [max]="totalPages" style="width: 50px; text-align: center;">
      </mat-form-field>
      <span>–</span>
      <mat-form-field class="page-range-input" appearance="outline">
        <input matInput type="number" [(ngModel)]="interiorPageEnd" [ngModelOptions]="{standalone: true}" [min]="interiorPageStart" [max]="totalPages" style="width: 50px; text-align: center;">
      </mat-form-field>
      <span class="page-range-of" i18n="@@of">of</span> {{totalPages}}
      <button mat-icon-button [disabled]="!hasNextPages" (click)="showNextPages()" i18n-title="@@Next Pages" title="Next Pages"><mat-icon>chevron_right</mat-icon></button>
      <button mat-stroked-button *ngIf="interiorPageEnd < totalPages" (click)="showAllPages()" style="margin-left: 8px; color: white; border-color: rgba(255,255,255,0.5);" i18n="@@Show All">Show All</button>
      <button mat-stroked-button *ngIf="interiorPageEnd >= totalPages && totalPages > PAGE_CHUNK" (click)="resetPageRange()" style="margin-left: 8px; color: white; border-color: rgba(255,255,255,0.5);" i18n="@@Show First Pages">Show First Pages</button>
    </div>

    <div class="spreads-area" #spreadsPreviewArea style="overflow: auto;">
      <div #interiorContent [style.width.px]="scaledInteriorWidth || null" [style.height.px]="scaledInteriorHeight || null" style="overflow: hidden;">
        <div [style.transform]="'scale(' + effectiveInteriorZoom / 100 + ')'" [style.transform-origin]="'top left'" style="display: inline-block;">
          <div class="spread" *ngFor="let pageNumber of pageNumbers(2)">
            <app-book-preview-spread
              [book]="book"
              [leftPageNumber]="pageNumber"
              [rightPageNumber]="pageNumber + 1"
              [dpi]="288">
            </app-book-preview-spread>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="book.body?.standardized !== 'COMPLETE'" class="status-placeholder-small">
    <mat-icon>description</mat-icon>
    <span i18n="@@Body">Body</span>: {{getStatusLabel(book.body?.standardized || 'UNKNOWN')}}
  </div>

</div>
<div *ngIf="!book || !book.body || !book.cover" i18n="@@No Book">No Book</div>

